import { TextInput } from '@soteria/design-system-ve';

import * as styles from './CommunityDialog.css';

interface BasicInfoSectionProps {
  name: string;
  setName: (value: string) => void;
  bigId: string;
  setBigId: (value: string) => void;
  disabled?: boolean;
}

export function BasicInfoSection({ name, setName, bigId, setBigId, disabled = false }: BasicInfoSectionProps) {
  return (
    <div className={styles.formSection}>
      {/* Community Name and Microsoft Store ID in asymmetric row */}
      <div className={styles.formGroupRowAsymmetric}>
        <TextInput
          required
          disabled={disabled}
          id="communityName"
          label="Community Name"
          placeholder="Enter community name"
          value={name}
          onChange={(value: string) => setName(value)}
        />
        <TextInput
          disabled={disabled}
          helperText="Used to fetch logo and hero images"
          id="microsoftStoreId"
          label="Microsoft Store ID"
          placeholder="Store ID (optional)"
          value={bigId}
          onChange={(value: string) => setBigId(value)}
        />
      </div>
    </div>
  );
}
